import BaseFileSearchPageMixin from "@/modules/core/file/protected/BaseFileSearchPageMixin";
import SearchParametersEditor from "./MicroCreditFileSearchParametersEditor";
import service from "./MicroCreditFileService";

export default {
  mixins: [BaseFileSearchPageMixin],

  components: {
    SearchParametersEditor
  },

  props: {
    columns: {
      default() {
        return [
          {
            key: "status",
            label: this.$t("file.fields.status"),
            sortBy: "status.label",
            value: ({ row }) => row.status.label,
            onClick: ({ row }) => {
              this.$router.push({
                name: "MicroCreditFile",
                params: { id: row.id }
              });
            },
            styleClass: ({ row }) => {
              if (!row) {
                return "col"; // Header
              } else {
                return "col bg-" + this.variantFor(row.status);
              }
            }
          },
          {
            key: "exceedingDays",
            label: this.$t("file.fields.exceedingDays"),
            styleClass: ({ row }) => {
              if (!row) {
                return "col"; // Header
              } else {
                return row.exceedingDays > 0 ? "col bg-danger" : "col";
              }
            }
          },
          {
            key: "requestedAmount",
            label: this.$t("microCreditFile.fields.requestedAmount"),
            sortBy: "requestedAmount",
            value: ({ row }) => "€ " + this.$number2text(row.requestedAmount)
          },
          {
            key: "providedAmount",
            label: this.$t("microCreditFile.fields.providedAmount"),
            sortBy: "providedAmount",
            value: ({ row }) => "€ " + this.$number2text(row.providedAmount)
          },
          {
            key: "title",
            label: this.$t("microCreditRequest.fields.title"),
            sortBy: "title"
          },
          {
            key: "customer",
            label: this.$t("request.fields.customer"),
            sortBy: "request.customer.companyName",
            value: ({ row }) => row.request.customer.companyName
          }
          /*
          {
            key: 'lastModified',
            label: this.$t('common.lastModified'),
            sortBy: 'lastModified'
          },
          */
        ];
      }
    }
  },

  data() {
    return {
      sort: {
        sort: "title",
        order: "ASC"
      }
    };
  },

  methods: {
    getService() {
      return service;
    }
  }
};
